// extracted by mini-css-extract-plugin
export default {"list_header":"Employees_list_header__EONrx","role":"Employees_role__ttJei","info":"Employees_info__7TH+g","tooltip":"Employees_tooltip__u3ecE"};